import { Plane } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const AdvanceParole = () => {
  const faqs = [
    {
      question: "Who needs advance parole?",
      answer: "Advance parole is required for individuals with pending adjustment of status applications, DACA recipients, TPS holders, and others in temporary status who need to travel internationally. Leaving without advance parole can abandon your application or status.",
    },
    {
      question: "How long does it take to get advance parole?",
      answer: "Processing times vary but typically range from 3-6 months. We recommend applying well in advance of planned travel. In emergency situations, expedited processing may be available for humanitarian reasons or significant public benefit.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">Travel Safely While Your Case Is Pending</h2>
        <p className="text-xl text-muted-foreground mb-8">
          If you're applying for a green card or have certain types of immigration relief, leaving the U.S. without permission can put your case—and your future—at serious risk. That's where Advance Parole comes in.
        </p>

        <h3 className="text-2xl font-bold mb-4">What Is Advance Parole?</h3>
        <p className="mb-6">
          Advance Parole (Form I-131) is a travel document that allows eligible immigrants to leave the U.S. temporarily and return without abandoning their pending immigration applications. It's essential for those with adjustment of status applications, DACA, TPS, or asylum cases.
        </p>

        <h3 className="text-2xl font-bold mb-4">Who Can Apply?</h3>
        <ul className="list-disc pl-6 mb-6">
          <li>Adjustment of status applicants (Form I-485 pending)</li>
          <li>DACA recipients</li>
          <li>TPS beneficiaries</li>
          <li>Asylum applicants</li>
          <li>Certain refugees and parolees</li>
        </ul>

        <h3 className="text-2xl font-bold mb-4">Reasons for Advance Parole</h3>
        <ul className="list-disc pl-6 mb-8">
          <li>Humanitarian reasons (family emergency, medical treatment)</li>
          <li>Educational purposes (conferences, research)</li>
          <li>Employment reasons (business meetings, training)</li>
        </ul>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title="Advance Parole"
      subtitle="Travel authorization for those with pending immigration applications"
      icon={<Plane className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default AdvanceParole;
